import React from 'react'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import configPrint from '../../../print-config.json'
import config from '../../../config.json'
import PrintTypeItem from './PrintTypeItem';

const ChoosePrintType = ({
    usedWebToPrintRoutes, 
    basicUrl,
    closePagePath,
}) => (
    <WrapperPageSimple 
        pageTitleTransId={config.routes.webtoprint.transId} 
        closePagePath={closePagePath}
    >
        <div className="print-page print-type site-content">
            {usedWebToPrintRoutes[0] ? usedWebToPrintRoutes.map((routeKey) => {
                const item = configPrint.routes[routeKey]
                const transIdname = item.transIdname
                const transIdDescription = item.transIdDescription
                const path = `${basicUrl}/${item.path}`

                return (
                    <PrintTypeItem 
                        key={routeKey} 
                        id={routeKey} 
                        transIdname={transIdname} 
                        path={path} 
                        transIdDescription={transIdDescription}
                    />
                )
            }) : (
                <div>Bitte kontaktieren Sie unseren <a className="support-mail text-regular-color cursor-pointer" href="mailto:support@pmkino.com">Support</a></div>
            )}
        </div>
    </WrapperPageSimple>
)

export default ChoosePrintType  